import { useMutation } from '@apollo/client';
import { Box, Grid, Modal, Typography } from '@mui/material';
import { Field, Formik } from 'formik';
import React from 'react';
import { ButtonComponent } from '../../../components/mui-button';
import { toastNotification } from '../../../components/toastify';
import { SelectCidades } from '../../../containers/selects/mui-cidades';
import { CREATE_CAMPANHA_DINAMICA_CIDADE } from '../../../graphql/mutation';

const AdicionarCidadeModal = ({openModal, onClose, campanhaId}) => {
  const [cidade, setCidade] = React.useState(null);

  const [createCidade, {loading}] = useMutation(CREATE_CAMPANHA_DINAMICA_CIDADE);

  const adicinarCidade = () => {
    if (loading || !cidade) return;

    createCidade({variables: {cidadeId: cidade.value, campanhaId}})
      .then(() => {
        onClose();
      })
      .catch((error) => {
        toastNotification({
          titulo: error.message || 'Ocorreu um erro ao adicionar a cidade!',
          type: 'error',
        });
      });
  };

  return (
    <Modal
      open={openModal}
      onClose={() => onClose()}
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
      sx={styles.modal}>
      <Box>
        <Formik initialValues={{cidade: null}} enableReinitialize>
          <Grid sx={styles.modalBody}>
            <Grid item>
              <Typography sx={styles.modalSubtitle}>Selecione a cidade</Typography>
            </Grid>
            <Grid item sx={styles.instaladorContainer}>
              <Field component={SelectCidades} name="cidade" label="Cidade" onChange={setCidade} />
            </Grid>
            <Grid container item xs={12} spacing={2} pt={2}>
              <Grid item xs={6}>
                <ButtonComponent id="button-cancel" value="Cancelar" onClick={onClose} disabled={loading} />
              </Grid>
              <Grid item xs={6}>
                <ButtonComponent id="button" value="Adicionar" onClick={adicinarCidade} disabled={loading} loading={loading} />
              </Grid>
            </Grid>
          </Grid>
        </Formik>
      </Box>
    </Modal>
  );
};

const styles = {
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalBody: {
    padding: '20px',
    background: '#fff',
    borderRadius: '5px',
    minWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
  },
  modalTitle: {
    fontWeight: '700',
    fontSize: '13px',
    marginBottom: '15px',
    color: '#afafaf',
  },
  modalSubtitle: {
    fontWeight: '500',
  },
  modalButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '5px',
  },
  instaladorContainer: {
    marginTop: '15px',
    textAlign: 'left',
  },
};

export default AdicionarCidadeModal;
